<ng-container>

  <div>
    <b>{{ name }}</b>
    <app-info class="formGroupLabel" [wide]="false" [placement]="'left'">
      <div class="tooltipContent">
        <b>Considering</b>
        <ul>
          @for (consider of splitConsidering(); track consider) {
            <div>
              <li>
                {{ consider }}
              </li>
            </div>
          }
        </ul>
      </div>
    </app-info>
  </div>

  <ng-container>
    <div class="row">
      <div class="col-md fieldset">
        <app-visit-exemptions-exemption-common [exemption]="exemption"></app-visit-exemptions-exemption-common>

        <div class="row">
          <app-form-group label="Length between perpendiculars (m)">
            <input [(ngModel)]="exemption.lengthBetweenPerpendiculars" id="lengthBetweenPerpendiculars" type="number"
                   appDecimalNumber [maxDecimals]="2" class="form-control" required>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Full manoeuvring speed (kn)">
            <input [(ngModel)]="exemption.fullManoeuvringSpeed" id="fullManoeuvringSpeed" type="number"
                   maxlength="32" class="form-control" required>
          </app-form-group>
        </div>

        <div class="row">
          <div class="label">Seawater arrival draught</div>
          <div class="card pt-3">
            <app-form-group label="Fore ship (m)">
              <input [(ngModel)]="exemption.arrivalDraughtForeShip" id="arrivalDraughtForeShip" type="number"
                     appDecimalNumber [maxDecimals]="2" class="form-control" required>
            </app-form-group>
            <app-form-group label="Amidships (m)">
              <input [(ngModel)]="exemption.arrivalDraughtAmidships" id="arrivalDraughtAmidships" type="number"
                     appDecimalNumber [maxDecimals]="2" class="form-control" required>
            </app-form-group>
            <app-form-group label="Aft ship (m)">
              <input [(ngModel)]="exemption.arrivalDraughtAftShip" id="arrivalDraughtAftShip" type="number"
                     appDecimalNumber [maxDecimals]="2" class="form-control" required>
            </app-form-group>
          </div>
        </div>
      </div>

      <div class="col-md fieldset">
        <div class="row">
          <app-form-group label="Gyrocompass operational ?">
            <app-yes-no [(ngModel)]="exemption.gyrocompassOperational" id="gyrocompassOperational"
                        required></app-yes-no>
          </app-form-group>
          <app-form-group label="Radar operational ?">
            <app-yes-no [(ngModel)]="exemption.radarOperational" id="radarOperational" required></app-yes-no>
          </app-form-group>
          <app-form-group label="GMDSS operational ?">
            <app-yes-no [(ngModel)]="exemption.gmdssOperational" id="GMDSSOperational" required></app-yes-no>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>Metacentric height (m)</label>
              <div class="tooltipContent">G'M Solid</div>
            </app-info>
            <input [(ngModel)]="exemption.metacentricHeight"
                   id="metacentricHeight" type="number" appDecimalNumber [maxDecimals]="2" class="form-control" required>
          </app-form-group>
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>Free surface correction (m)</label>
              <div class="tooltipContent">GG'</div>
            </app-info>
            <input [(ngModel)]="exemption.freeSurfaceCorrection"
                   id="freeSurfaceCorrection" type="number" appDecimalNumber [maxDecimals]="2" class="form-control"
                   required>
          </app-form-group>
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>Corrected metacentric height (m)</label>
              <div class="tooltipContent">Corrected Metacentric height (G'M Fluid) = Metacentric height (G'M Solid)
                minus Free surface correction (GG')
              </div>
            </app-info>
            <input [(ngModel)]="exemption.correctedMetacentricHeight" id="correctedMetacentricHeight" type="number"
                   appDecimalNumber [maxDecimals]="2" class="form-control">
          </app-form-group>
        </div>

        <div class="row">
          <app-form-group label="Displacement Tonnage">
            <input [(ngModel)]="exemption.displacementTonnage" type="number" class="form-control">
          </app-form-group>
        </div>

        <div class="row">
          <app-form-group label="Vessel fitted with helicopter landing area or ICS winch only area ?">
            <app-yes-no [(ngModel)]="exemption.vesselFittedWithArea" id="vesselFittedWithArea" required></app-yes-no>
          </app-form-group>
        </div>
        <div class="row">
          @if (exemption.vesselFittedWithArea) {
            <app-form-group
              label="Location landing area or ICS winch only area">
              <input [(ngModel)]="exemption.locationArea" id="locationArea" type="text" maxlength="256"
                     class="form-control" required>
            </app-form-group>
          }
          @if (exemption.vesselFittedWithArea) {
            <app-form-group label="Helicopter landing permitted ?">
              <app-yes-no [(ngModel)]="exemption.helicopterLandingPermitted" id="helicopterLandingPermitted"
                          required></app-yes-no>
            </app-form-group>
          }
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
